app.service("OrderHistoryService", ['$rootScope', function ($rootScope) {


    const service = this;

    const modelConstructor = $rootScope.model_constructor;
    const siteHelper = $rootScope.site_helper;

    const requestService = $rootScope.service.request;

    const OrderHistoryModel = modelConstructor.extend(modelConstructor.BasicModel, {
        name: "Order History",
        id: "order_history",
        order_type_id: null,
        query_max: 100,
        limit: 0,
        customer_code: null,
        status: null,
        request_in_progress: false,
        requestCallbacks: [],
        getOrderID: function (order) {
            return order.id;
        },
        requestOrders: requestOrders

    });

    this.factory = new modelConstructor.ModelFactory({
        birth: function (values) {
            return new OrderHistoryModel(values);
        },

        validVariationPointers: function (variationIDs) {
            return ['order_type_id', 'limit', 'customer_code', 'status'];
        },
        applyModelVariation: applyModelVariation
    });


    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;

        model.order_type_id = variationIDs.order_type_id ? variationIDs.order_type_id : null;
        model.limit = variationIDs.limit ? parseInt(variationIDs.limit) : model.query_max;
        model.customer_code = variationIDs.customer_code ? variationIDs.customer_code : null;
        if (model.order_type_id === "weborder" || model.order_type_id === "webquote") {

            siteHelper.applyValues(model, {
                getOrderID: function (order) {
                    return order._id;
                }
            });
        }
    }

    function getVariationModel(orderTypeID, limit, customerCode) {
        const variationIDs = {order_type_id: orderTypeID};
        if (limit) {
            variationIDs.limit = limit;
        }
        if (customerCode) {
            variationIDs.customer_code = customerCode;
        }
        return $rootScope.factory.order_history.getModel(variationIDs);
    }

    service.getSubmittedModel = function (limit, customerCode) {
        return getVariationModel("order", limit, customerCode)
    }

    service.getWebModel = function (limit) {
        return getVariationModel("weborder", limit)
    }

    service.getQuoteModel = function (limit) {
        return getVariationModel("webquote", limit)
    }

    function requestOrders(callback) {
        const model = this.root;
        if (callback) {
            model.requestCallbacks.push(callback);
        }
        if (model.request_in_progress) {
            return
        }
        model.request_in_progress = true;
        let endpoint = '/request/api.php/orders/?type=' + model.order_type_id + '&include_lines=false&limit=' + model.limit;
        if (model.customer_code) {
            endpoint += "&customer_code=" + model.customer_code;
        }
        if (model.status) {
            endpoint += "&status=" + model.status;
        }

        requestService.getRequest(endpoint, function (success, data, messages) {
            model.request_in_progress = false;
            let i;
            if (success) {
                model.choice_order.length = 0;
                for (i = 0; i < data.length; i++) {
                    const order = data[i];
                    order.status_name = siteHelper.uppercaseFirstWords((((order.status ?? "").toString()).split("_").join(" ")).toLowerCase());
                    const orderID = model.getOrderID(order);
                    model.choice_order.push(orderID)
                    model.choices[orderID] = order;
                }
            }
            const choiceList = model.choiceList();
            for (i = 0; i < model.requestCallbacks.length; i++) {
                model.requestCallbacks[i](success, choiceList, messages);
            }
            model.requestCallbacks.length = 0;
        })
    }

    service.requestArchive = function (orderTypeID, listModel, searchModel, customerCode, callback) {

        function handleResponse(success, orderList, message) {
            orderList = orderList ? orderList : [];

            for(let i = 0; i < orderList.length; i++) {
                const order = orderList[i];
                order.status_name = siteHelper.uppercaseFirstWords((((order.status ?? "").toString()).split("_").join(" ")).toLowerCase());
            }

            listModel.cloneList(orderList);
            if (success && orderList.length === 0) {
                if (orderList.length === 0) {
                    message = "No results were found. You should change your criteria and try again"
                }
            }
            listModel.response_message = message ? message : "";
            if (callback) {
                callback(success, orderList, message)
            }
        }

        listModel.response_message = "";

        let query = "";
        if (searchModel.search_terms) {
            if (searchModel.search_terms.length < 3) {
                handleResponse(false, null, "Note that keywords require a minimum of 3 characters");
                return;
            }
            query += "&q=" + searchModel.search_terms;
        }
        if (searchModel.from) {
            query += "&from=" + searchModel.from;
        }
        if (searchModel.until) {
            query += "&until=" + searchModel.until;
        }
        if (!query) {
            handleResponse(false, null, "No search criteria entered");
            return;
        }
        listModel.in_progress = true;

        let endpoint = '/request/api.php/orders?include_lines=false&type=' + orderTypeID + '&limit=' + searchModel.limit + query;
        if (customerCode) {
            endpoint += "&customer_code=" + customerCode;
        }
        requestService.getRequest(endpoint, function (success, orderList, messages) {
            handleResponse(success, orderList, messages && messages.length > 0 ? messages[0].msg : null);
        })
    }

}]);